'use client';

import { createContext } from 'react';

import { User } from '../../shared/models/user.model';

export interface AuthenticationContextValue {
   loading: boolean;
   canAuthenticate: boolean;
   user: User | undefined;
   accessToken: string | undefined;
   refreshToken: () => Promise<void>;
   login: (redirectUrl?: string, language?: string) => void;
   logout: () => void;
}

export const AuthenticationContext = createContext<AuthenticationContextValue | null>(null);
